module.exports = __webpack_public_path__ + "img/rectangle-slider.8f8cf4cd.svg";